import React from "react";
import { LOCATION_FIELDS } from "./constants";

function LocationView(props) {
  const { location } = props;
  const getLocationValue = (value) => {
    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }
    if (Array.isArray(value)) {
      return value.map((item) => <div key="item">{item}</div>);
    }
    return value;
  };
  return (
    <>
      <div className="modal fade location-modal show" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header text-center">
              <h4 className="modal-title w-100 font-weight-bold">Location Details</h4>
              <button type="button" className="close" aria-label="Close" onClick={props.onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-3">
              <table className="table table-hover table-bordered bg-white">
                <thead>
                  <tr>
                    <th>Property</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(LOCATION_FIELDS).map((key) => (
                    <tr key={key}>
                      <td>{LOCATION_FIELDS[key].label || key}</td>
                      <td>{getLocationValue(location[key])}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button className="btn btn-indigo" onClick={props.onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default LocationView;
